import { render, staticRenderFns } from "./UmbInvestmentAccountPage.vue?vue&type=template&id=3a61bd80&scoped=true"
import script from "./UmbInvestmentAccountPage.vue?vue&type=script&lang=ts"
export * from "./UmbInvestmentAccountPage.vue?vue&type=script&lang=ts"
import style0 from "./UmbInvestmentAccountPage.vue?vue&type=style&index=0&id=3a61bd80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a61bd80",
  null
  
)

export default component.exports